import { useMemo } from 'react';
import { getEventTypeConfig, getEventTypeId, isEventFeatureEnabled } from '../config/eventTypes';

export function useEventTypeConfig(event) {
  const eventType = event?.event_type;
  const itineraryEnabled = event?.itinerary_enabled;
  const accommodationEnabled = event?.accommodation_enabled;
  return useMemo(() => {
    const typeId = getEventTypeId(eventType);
    const config = getEventTypeConfig(typeId);
    const features = {
      ...config.features,
      showItinerary: isEventFeatureEnabled({
        event_type: eventType,
        itinerary_enabled: itineraryEnabled,
      }, 'showItinerary'),
      showAccommodation: isEventFeatureEnabled({
        event_type: eventType,
        accommodation_enabled: accommodationEnabled,
      }, 'showAccommodation'),
    };

    return {
      typeId,
      ...config,
      features,
      isWedding: typeId === 'wedding',
      isCorporate: typeId === 'corporate',
      isBabyShower: typeId === 'baby_shower',
      isBirthday: typeId === 'birthday',
      showFeature(featureName) {
        return Boolean(features?.[featureName]);
      },
    };
  }, [eventType, itineraryEnabled, accommodationEnabled]);
}

export default useEventTypeConfig;
